import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";

@Component({
  moduleId: module.id,
  selector: 'site-v1ComponentInfo',
  templateUrl: './v1ComponentInfo.component.html',
  styleUrls: ['./v1ComponentInfo.component.css']
})

export class v1ComponentInfo {
  @Input()
  routingLink: String;

  @Input()
  contentTitle: String;

  @Input()
  contentSubtitle: String;

  @Input()
  contentList: ContentModel[];

  // @Input()
  // contributorList: string[];

  @Input()
  contributorList: ContentModel;
}

export class ListContent {

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/v1ComponentInfo/v1ComponentInfo.component.ts